import React, { useState } from 'react'

import FileExcelIcon from '@mui/icons-material/GridOn'
import FilePdfIcon from '@mui/icons-material/PictureAsPdf'
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'

export const FILE_FORMATS = [
  {
    key: 'pdf',
    name: 'PDF',
    Icon: FilePdfIcon,
  },
  {
    key: 'excel',
    name: 'Excel',
    Icon: FileExcelIcon,
  },
]

type CampaignReportButtonProps = {
  onFormatSelect: (...args: any[]) => any
}

const CampaignReportButton = ({ onFormatSelect }: CampaignReportButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<any>(null)

  const handleMenuClose = () => setAnchorEl(null)

  const handleMenuItemClick = (format: any) => () => {
    onFormatSelect(format)
    handleMenuClose()
  }

  return (
    <>
      <Button
        aria-haspopup="true"
        aria-owns={anchorEl ? 'simple-menu' : undefined}
        onClick={event => setAnchorEl(event.currentTarget)}>
        Report
      </Button>
      <Menu anchorEl={anchorEl} id="simple-menu" onClose={handleMenuClose} open={Boolean(anchorEl)}>
        {FILE_FORMATS.map(({ key, name, Icon }) => (
          <MenuItem key={key} onClick={handleMenuItemClick(key)}>
            <ListItemIcon>
              <Icon />
            </ListItemIcon>
            <ListItemText inset primary={name} />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default CampaignReportButton
